import { useEffect, useRef } from 'react'
import { LifeBuoy } from 'lucide-react'

export default function SupportPage() {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    // Get WordPress configuration
    const wpConfig = (window as any).WP_COCKPIT
    const fluentSupportActive = wpConfig?.fluentSupportActive ?? false
    const externalSupportUrl = wpConfig?.externalSupportUrl ?? 'https://kaizen.kainjoo.com/cockpit/support'
    
    // If Fluent Support is not active, redirect to external support
    if (!fluentSupportActive) {
      window.open(externalSupportUrl, '_blank')
      // Go back to previous page
      window.history.back()
      return
    }
    
    const siteUrl = wpConfig?.restApiUrl?.replace('/wp-json/', '') || window.location.origin
    
    // Create a dedicated support portal URL
    const supportUrl = `${siteUrl}/wp-admin/admin-ajax.php?action=kj_cockpit_support_portal`
    
    if (iframeRef.current) {
      iframeRef.current.src = supportUrl
    }
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
                <LifeBuoy className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Support</h1>
                <p className="text-gray-600 dark:text-gray-400 mt-1">
                  Get help and submit support tickets
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Fluent Support Portal iframe */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden">
          <iframe
            ref={iframeRef}
            className="w-full border-0"
            style={{ minHeight: '800px', height: 'calc(100vh - 200px)' }}
            title="Support Portal"
          />
        </div>
      </div>
    </div>
  )
}
